//
//
//
//
//
//
//

export default {
    props: {
        markers: Array,
        longitude: [String, Number],
        latitude: [String, Number],
        scale: {
            default: 10,
            type: Number
        }
    },
    data () {
        return {
            qqmap: '',
            premarker: '',
            created_markers: [],
            inputVal: '',
            latlngCurrent: ''
        }
    },
    mounted () {
        this.createMap()
        this.$watch(() => {
            return [this.latitude, this.longitude]
        }, (center) => {
            if (center.filter(v => v).length) {
                this.qqmap.panTo(new qq.maps.LatLng(...center))
            }
        })
    },
    watch: {
        scale (scale) {
            this.qqmap.zoomTo(scale)
        },
        markers: {
            handler (markers) {
                console.log(1, markers.length)
                console.log(2, this.qqmap)
                if (this.qqmap && markers) {
                    this.$nextTick(() => {
                        this.changeMakers(markers)
                    })
                }
            },
            immediate: true
        }
    },
    methods: {
        createMap() {
            this.qqmap = new qq.maps.Map(document.getElementById("qq-map"), {
                zoom: this.scale || 10,
                center: new qq.maps.LatLng(30.648116, 104.071595)
            })
        },
        changeMakers (markers) {
            this.created_markers.forEach((item) => {
                item.label.setMap(null)
                item.marker.setMap(null)
            })
            this.created_markers = markers.map((item) => this.createMarker(item))
        },
        createMarker(item) {
            const center = new qq.maps.LatLng(item.latitude, item.longitude)
            const marker = new qq.maps.Marker({
                title: item.title || '',
                position: center,
                map: this.qqmap
            })
            if (item.iconPath) {
                marker.setIcon( new qq.maps.MarkerImage(
                    item.iconPath,
                    new qq.maps.Size(item.width, item.height),
                    new qq.maps.Point(0, 0),
                    new qq.maps.Point(0, 0),
                    new qq.maps.Size(item.width, item.height)
                ))
            }
            let label_style = {
            }
            if (item.callout) {
                label_style = {
                    ...item.callout,
                    backgroundColor: item.callout.bgColor
                }
            }
            const content = (item.callout && item.callout.content ? item.callout.content : item.title).replace('\n', '<br/>')
            const label = new qq.maps.Label({
                position: center,
                map: item.callout ? this.qqmap : null,
                offset: new qq.maps.Size(-18, item.height),
                content,
                style: label_style
            })
            const callout = () => {
                this.qqmap.panTo(center)
                this.$emit('callouttap', {
                    markerId: item.id,
                    target: {},
                    mp: {
                        markerId: item.id
                    }
                })
            }
            qq.maps.event.addListener(marker, 'click', callout)
            qq.maps.event.addListener(label, 'click', callout)
            return {
                marker,
                label
            }
        }
    }
}
